import { MouseEvent, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { Button, Grid } from '@mui/material';
import { useIsAdmin } from 'features/auth/hooks/useIsAdmin';
import CurrentUsersTable from './CurrentUsersTable';
import {
  bootTimeshareUser,
  joinTimeshare,
  leaveTimeshare,
} from 'features/spectrasWebSocketServer/spectrasWebSocketServerSlice';
import { useTimeshareMessages } from './hooks/useTimeshareMessages';
import { useWatchTimeshareChannel } from './hooks/useWatchTimeshareChannel';
import TimeshareTotalSweepTime from './TimeshareTotalSweepTime';
import GreenButton from 'components/GreenButton';

interface Props {
  analyzerId: number;
  snapshotId: number;
}

const TimeShare = ({ analyzerId, snapshotId }: Props) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user);
  const [selectedUser, setSelectedUser] = useState<number>(-1);
  const { inTimeshare, timeshareUsers } = useTimeshareMessages();
  useWatchTimeshareChannel({ userId: user!.id, analyzerId });
  const isAdmin = useIsAdmin();

  const handleStartClicked = () =>
    dispatch(
      joinTimeshare({
        user_id: user!.id,
        snapshot_id: snapshotId,
        analyzer_id: analyzerId,
      })
    );

  const handleEndClicked = () =>
    dispatch(leaveTimeshare({ user_id: user!.id }));

  const handleBootClicked = () => {
    dispatch(
      bootTimeshareUser({ user_id: user!.id, user_id_to_boot: selectedUser })
    );
    setSelectedUser(-1);
  };

  const handleUserSelected = (event: MouseEvent<unknown>, userId: number) =>
    setSelectedUser(userId);

  return (
    <Grid container spacing={1}>
      <Grid
        item
        container
        xs={12}
        spacing={1}
        alignContent='center'
        justifyContent={'center'}
      >
        <Grid item xs={4}>
          {inTimeshare ? (
            <Button
              variant='contained'
              color='secondary'
              fullWidth
              onClick={handleEndClicked}
            >
              Leave
            </Button>
          ) : (
            <GreenButton name='Start' fullWidth onClick={handleStartClicked} />
          )}
        </Grid>
        {isAdmin && inTimeshare && (
          <Grid item xs={4}>
            <Button
              variant='contained'
              color='error'
              fullWidth
              value='Boot'
              onClick={handleBootClicked}
              disabled={selectedUser === -1}
            >
              Boot User
            </Button>
          </Grid>
        )}
      </Grid>
      <Grid item xs={12}>
        <TimeshareTotalSweepTime
          analyzerId={analyzerId}
          users={timeshareUsers}
        />
      </Grid>
      <Grid item xs={12}>
        <CurrentUsersTable
          users={timeshareUsers}
          selectedUser={selectedUser}
          handleClick={handleUserSelected}
        />
      </Grid>
    </Grid>
  );
};

export default TimeShare;
